// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"partner-listing-m__wrapper__3LheC","static-text":"partner-listing-m__static-text__2zKJ_","partners-logo":"partner-listing-m__partners-logo__16_rf"};